export const learningCenterPageStandard = {
  __typename: 'PageContentLearningCenterPage',
  sys: {
    id: '5af0ZW17dqC1jYqJR2qLcN',
  },
  internalTitle: 'Learning Center Category Page',
  sectionsCollection: {
    items: [
      {
        __typename: 'SectionLearningCenterMasthead2',
        sys: {
          id: '7nITXRHKjEyrjStVo6wDW',
        },
        paragraph: {
          json: {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'A little text',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'paragraph',
              },
            ],
            nodeType: 'document',
          },
        },
        heading: 'Everything you need to know about retirement',
        headingHighlight: null,
        searchInput: 'Search Learning Center',
        background: 'brightBlue10',
        imagesCollection: {
          items: [
            {
              sys: {
                id: 'TMcDbb9aRJE0PIlDgVehY',
              },
              altText: null,
              width: 413,
              height: 260,
              image: {
                title: 'Money plant wide',
                url: 'https://images.ctfassets.net/tj9jxg7kaxby/2RBEpYtUGbjmbqTVRsXBiO/b16075e3bf2db0009a0cafae61b58e64/Humanify_LP_UI_Kit__2_..png',
                description: 'Long haired person watering a plant made of money',
              },
            },
          ],
        },
      },
      {
        __typename: 'ComponentLearningCenterTopFilter',
        filtersCollection: {
          items: [
            {
              name: 'all',
              displayName: 'All',
              path: '/learn2/categories/all/',
            },
            {
              name: 'employers',
              displayName: 'For Employers',
              path: '/learn2/categories/employers',
            },
            {
              name: 'employees',
              displayName: 'For Employees',
              path: '/learn2/categories/employees',
            },
          ],
        },
      },
      {
        __typename: 'ComponentLearningCenterSideFilter',
        name: 'Category Page Filters',
        filtersCollection: {
          items: [
            {
              name: 'resourceType',
              displayName: 'Content Type',
              filtersCollection: {
                items: [
                  {
                    name: 'Articles',
                    displayName: 'Articles',
                  },
                  {
                    name: 'Guides',
                    displayName: 'Guides',
                  },
                  {
                    name: 'Calculators',
                    displayName: 'Calculators',
                  },
                ],
              },
            },
            {
              name: 'topics',
              displayName: 'Topic',
              filtersCollection: {
                items: [
                  {
                    name: '401k-compliance-and-administration',
                    displayName: '401(k) Compliance & Administration',
                  },
                  {
                    name: 'hr-benefits-and-payroll',
                    displayName: 'HR, Benefits & Payroll',
                  },
                  {
                    name: 'plan-design',
                    displayName: 'Retirement Plan Design',
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  },
  learningCenterResourceCollection: {
    items: [
      {
        sys: {
          id: 'zmevXlygjAzBTxm03hyxK',
        },
        title: 'Financial advisor’s quick guide to SECURE Act 2.0',
        lastModified: '2023-05-08T16:14:52.471Z',
        categories: ['legislation'],
        subcategories: ['federal-legislation', 'secure-act'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'secure-act-guide-financial-advisors',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/2BytcoFw5hfFrAkuIGg6gT/1f12df7fb313f1ecb07498aa7d9db9b0/financial_advisor_image.jpg',
          },
        },
      },
      {
        sys: {
          id: 'z3MrP0WxJJ1gpeME2gHMk',
        },
        title: 'How to ask your manager or boss about a 401(k) for your company',
        lastModified: '2022-03-14T22:08:49.270Z',
        categories: ['employees'],
        subcategories: ['financial-wellness'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'ask-manager-boss-401k-company',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/7jqml6JbUhqiqOYuRTXDhn/890a4a8baf194106cc50864e429ae9ae/discussion-2822066_1920-1-1.jpg',
          },
        },
      },
      {
        sys: {
          id: 'xU0bbxbxkKCpOmUsZUbcS',
        },
        title: 'Your guide to retirement law in Arizona',
        lastModified: '2022-12-05T00:10:12.011Z',
        categories: ['legislation'],
        subcategories: ['state-legislation'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'arizona-state-sponsored-retirement-plan',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/1jBQwJAegBtC77mAoFwIgd/640d313af8422306fac10ef09142dbf1/christoph-von-gellhorn-kjA82leKmJc-unsplash.jpg',
          },
        },
      },
      {
        sys: {
          id: 'wceghlEaAYWzlO9Z6FNn2',
        },
        title: 'All About Form 5500',
        lastModified: '2022-07-14T17:04:30.194Z',
        categories: ['employers'],
        subcategories: ['401k-compliance-and-administration'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'form-5500',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/6fjJxPRRk4pKp2H5pkPfUy/7e69f7f70a201db9092e7122caeb031f/15151598439_95c355f695_b-1463515887439-1-1.jpg',
          },
        },
      },
      {
        sys: {
          id: 'wVAKYFurorxWW2Wey8LVT',
        },
        title: 'Why we redesigned our participant enrollment and account experience',
        lastModified: '2022-03-14T22:06:04.109Z',
        categories: ['employers'],
        subcategories: ['plan-design'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'participant-enrollment-and-account-experience-redesign',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/4Tse2b0t28AVmF1ToMFFqX/33b31f54f87ef69e0c2f53bb5151f2b0/participant-redesign-dashboard.jpg',
          },
        },
      },
      {
        sys: {
          id: 'voyzrHJO512aZWNY160Fv',
        },
        title: 'Startup equity basics: What to ask before you accept',
        lastModified: '2023-08-17T20:51:28.804Z',
        categories: ['employees'],
        subcategories: ['financial-wellness'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'startup-equity-basics-ask-stock-accept',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/4HFXPSlKi7sLlk6v3NQGpa/b2fa7f2c2f2a6c3c07ceefc448b591f6/egg-1272815_1280-2-1.jpg',
          },
        },
      },
      {
        sys: {
          id: 'v5kvxKCqjkICKZ8MDrrgA',
        },
        title: 'The Debt We Owe',
        lastModified: '2023-07-06T19:03:42.326Z',
        categories: ['employees'],
        subcategories: ['saving-and-investing'],
        resourceType: 'Guides',
        resource: {
          __typename: 'LearningCenterGuide',
          slug: 'the-debt-we-owe',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/7Hs56gtxbv7ykgk7qY5PXh/cabc07cdd2972de4e1a57531bf73f9e8/Screenshot_2023-07-06_at_2.57_1_2x.png',
          },
        },
      },
      {
        sys: {
          id: 'upc1VleABGJwQvCu4Z4sB',
        },
        title: 'Donald Trump and Your 401(k): The Effect of a Presidential Election',
        lastModified: '2022-03-14T22:06:21.591Z',
        categories: ['employers'],
        subcategories: ['federal-legislation'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'donald-trump-and-your-401k-the-effect-of-a-presidential-election',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/3iaTKxKnaqj964Lu5ceGsI/73321f94e66fe17788655fb6a58abe48/flag-731350_1280-1-1.jpg',
          },
        },
      },
      {
        sys: {
          id: 'tBRAjIaBGtxDY6qzID82k',
        },
        title: 'Understanding the Department of Labor’s Fiduciary Rule',
        lastModified: '2022-03-14T22:07:33.172Z',
        categories: ['employers'],
        subcategories: ['401k-compliance-and-administration'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'understanding-the-department-of-labors-fiduciary-rule',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/3M1A6Doi1rg5kgLlmxChkV/c8441ea94a55457f3f11af3f3d155f52/katie-moum-o0kbc907i20-unsplash.jpg',
          },
        },
      },
      {
        sys: {
          id: 'uJIwNDf2LX6HY5fFkk0PE',
        },
        title: 'How to Convert Your 401(k) to Roth IRA',
        lastModified: '2022-03-14T22:07:37.168Z',
        categories: ['employees'],
        subcategories: ['401k-basics'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'how-to-convert-your-401k-to-roth-ira',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/7rY5FsefpU7DcUXOADcED8/e435258985458542746043310471e7e4/maria-teneva-ILRrC761WEE-unsplash.jpg',
          },
        },
      },
      {
        sys: {
          id: 'okw014od9CnEuMGVU3nLj',
        },
        title: 'Setting Up a Commuter Benefits Plan for a Small Business',
        lastModified: '2022-03-14T22:06:35.318Z',
        categories: ['employers'],
        subcategories: ['hr-benefits-and-payroll'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'setting-commuter-benefits-plan-small-business',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/6anKmxMWCrzXHp1mRSjIZ2/7222f461e14f809788b5aafa65fc914b/StockSnap_B3PYGHWIRM-e1487289243763-2.jpg',
          },
        },
      },
      {
        sys: {
          id: 'oGPuPQ4l0d6r4FouFhkAt',
        },
        title: 'How Much Should You Put in Your 401(k)?',
        lastModified: '2022-03-14T22:05:53.812Z',
        categories: ['employees'],
        subcategories: ['retirement-planning'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'how-much-should-you-put-in-your-401k',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/3zEfXcVomJPCPtMJFiatvK/3db831255c26b00b2f568520f6e25f19/pexels_photo__3_-1467159845099-1.jpg',
          },
        },
      },
      {
        sys: {
          id: 'mtM9LfiLOUBhHjhDQYEl2',
        },
        title: 'Small Business Employee Benefits',
        lastModified: '2022-03-14T22:05:47.746Z',
        categories: ['employers'],
        subcategories: ['hr-benefits-and-payroll'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'small-business-employee-benefits',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/7fCAtWTMOCylvktDBu0DsV/6ebb5b0f5e0d015d767164a1348c9bb4/mimi-thian-vdXMSiX-n6M-unsplash-scaled.jpg',
          },
        },
      },
      {
        sys: {
          id: 'm8WCrhJ8j0SZ7lPFGa5sl',
        },
        title: 'The Best States To Retire',
        lastModified: '2022-03-14T22:07:39.200Z',
        categories: ['employees'],
        subcategories: ['retirement-planning'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: 'the-best-states-to-retire',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/7AATSY3Yf2nlbhGDL1aE9Y/98b8555dbeda19a7aed5d4c929387770/jon-eckert-IoIbdFdGCnQ-unsplash-scaled.jpg',
          },
        },
      },
      {
        sys: {
          id: 'kEsaaLCIxIidx03UfVsq9',
        },
        title: '457(b) vs 401(k): What’s the difference?',
        lastModified: '2022-11-04T17:01:34.911Z',
        categories: ['employees'],
        subcategories: ['401k-basics'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: '457b-vs-401k-whats-the-difference',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/2e1pR6iVeQpcCMhJG5EOES/e437c8977e08e97b8f6fa5b94ccb662b/frederick-tubiermont-HAxFSsZ2GFw-unsplash.jpg',
          },
        },
      },
    ],
  },
};
